<template>
  <div style="">

    <template v-for="step in teacher.getSteps()">
      <template v-for="(point, pointIdx) in step.points">
        <div class="desc-container" v-bind:key="`${step.stepIdx}_${pointIdx}`"
             :data-stepIdx="step.stepIdx" style="display: none">
          <div class="title">{{point.name}}</div>
        </div>
      </template>
    </template>


  </div>
</template>

<script>
export default {
  name: "Infospots",
  props: ['teacher'],
}
</script>

<style scoped lang="less">

.desc-container {
  background: rgba(40, 40, 40, 0.8);
  color: #ffffff;
  border-radius: 3px;
  overflow: auto;
  -webkit-overflow-scrolling: touch;

  .title {
    font-size: 1.1em;
    text-align: center;
    padding: 5px;
  }
  .text {
    padding: 0 20px 20px 20px;
  }
}

</style>